import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/usingthesite",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Using the Site")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/dashboards",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dashboards")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/faqs",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "FAQs")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/changelog",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Change Log")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Dashboard Column Titles, Options and Explanations", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Transactions", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { id: "transaction" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Transaction Dashboard", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { id: "transactiondetail" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Transaction Detail Dashboard", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Reconciliation", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { id: "reconciliation" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Reconciliation Dashboard", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { id: "reconciliationdetail" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Reconciliation Detail Dashboard", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Commissions", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { id: "commission" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Commission Dashboard", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", { id: "commissiondetail" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Commission Detail Dashboard", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", { id: "detaildashboard" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Detail Dashboard Messages and Statuses", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Explanations", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        class: "pad-v-20",
        gutter: 20
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createVNode(_component_el_table, {
                data: _ctx.transactionData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_divider),
              _hoisted_9,
              _hoisted_10,
              _createVNode(_component_el_table, {
                data: _ctx.transactionDetailData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.explanation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_divider),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createVNode(_component_el_table, {
                data: _ctx.reconciliationData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.explanation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_divider),
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_el_table, {
                data: _ctx.reconciliationDetailData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.explanation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_divider),
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_el_table, {
                data: _ctx.commissionData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _hoisted_19,
              _hoisted_20,
              _createVNode(_component_el_table, {
                data: _ctx.commissionDetailData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Name",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "options",
                    label: "Options",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.explanation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_el_divider),
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createVNode(_component_el_table, {
                data: _ctx.detailMessagesData,
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "message",
                    label: "Message",
                    "min-width": 20
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "status",
                    label: "Status",
                    "min-width": 15
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "explanation",
                    label: "Explanation",
                    "min-width": 65
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}